import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { FLOORS_ITEM_WIDTH, FLOORS_PAGE_ANIMATION_DURATION } from '../../../../../../../constants/filters';
import { runAnimation } from '../../../../../../../utils';
export var useFloorPanel = function useFloorPanel(floors) {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    hasNextFloors = _React$useState2[0],
    setHasNextFloors = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    hasPrevFloors = _React$useState4[0],
    setHasPrevFloors = _React$useState4[1];
  var _React$useState5 = React.useState(0),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    page = _React$useState6[0],
    setPage = _React$useState6[1];
  var _React$useState7 = React.useState(0),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    panelWidth = _React$useState8[0],
    setPanelWidth = _React$useState8[1];
  var _React$useState9 = React.useState(0),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    pageLimit = _React$useState10[0],
    setPageLimit = _React$useState10[1];
  var panelRef = React.useRef(null);
  React.useLayoutEffect(function () {
    if (!panelRef.current) {
      return;
    }
    function updateWidth() {
      var rect = panelRef.current.getBoundingClientRect();
      var limit = Math.floor(rect.width / FLOORS_ITEM_WIDTH);
      var notInLimit = floors.length - 1 > limit;
      setPanelWidth(rect.width);
      setPageLimit(limit);
      setHasNextFloors(notInLimit);
    }
    window.addEventListener('resize', updateWidth);
    updateWidth();
    return function () {
      return window.removeEventListener('resize', updateWidth);
    };
  }, [floors]);
  var animatePage = function animatePage(isNext, isLastPage) {
    runAnimation(function (progress) {
      if (!panelRef.current) {
        return;
      }
      var nextPage = isNext ? page + 1 : page - 1;
      var initialValue = -panelWidth * page;
      var finalValue = -panelWidth * nextPage;
      var isNextLastPage = floors.length * FLOORS_ITEM_WIDTH + finalValue < panelWidth;
      var isPrevLastPage = floors.length * FLOORS_ITEM_WIDTH + initialValue < panelWidth;
      if (isNextLastPage && isNext) {
        finalValue = -(floors.length * FLOORS_ITEM_WIDTH - panelWidth);
      }
      if (isPrevLastPage && !isNext) {
        initialValue = -(floors.length * FLOORS_ITEM_WIDTH - panelWidth);
      }
      var result = initialValue + (finalValue - initialValue) * progress;
      panelRef.current.style.transform = "translateX(".concat(result, "px)");
    }, isLastPage ? FLOORS_PAGE_ANIMATION_DURATION / 3 : FLOORS_PAGE_ANIMATION_DURATION);
  };
  var onNextButtonClick = function onNextButtonClick() {
    var nextPage = page + 1;
    var restFloors = floors.length - nextPage * pageLimit;
    setHasNextFloors(restFloors > pageLimit);
    setHasPrevFloors(true);
    animatePage(true, restFloors <= pageLimit);
    setPage(nextPage);
  };
  var onPrevButtonClick = function onPrevButtonClick() {
    var nextPage = page - 1;
    var restFloors = floors.length - nextPage * pageLimit;
    setHasNextFloors(restFloors > pageLimit);
    setHasPrevFloors(page > 1);
    animatePage(false, !hasNextFloors);
    setPage(nextPage);
  };
  return {
    hasNextFloors: hasNextFloors,
    hasPrevFloors: hasPrevFloors,
    onNextButtonClick: onNextButtonClick,
    onPrevButtonClick: onPrevButtonClick,
    panelRef: panelRef
  };
};